var exports = {
  "O0": "MenuItemRadio.module__radioButton___SVFjcU",
  "X3": "MenuItemRadio.module__radioButtonSelected___SVFjcU",
  "EC": "MenuItemRadio.module__radioButtonUnselected___SVFjcU",
  "$l": "MenuItemRadio.module__radioIndicator___SVFjcU",
  "aT": "MenuItemRadio.module__labelContent___SVFjcU",
  "Kk": "MenuItemRadio.module__icon___SVFjcU",
  "QK": "MenuItemRadio.module__labelText___SVFjcU",
};

module.exports = exports;
